import { render, staticRenderFns } from "./TodoItem.vue?vue&type=template&id=da2d3198&scoped=true&"
import script from "./TodoItem.vue?vue&type=script&lang=js&"
export * from "./TodoItem.vue?vue&type=script&lang=js&"
import style0 from "./TodoItem.vue?vue&type=style&index=0&id=da2d3198&prod&scoped=true&lang=css&"
import style1 from "./TodoItem.vue?vue&type=style&index=1&id=da2d3198&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2d3198",
  null
  
)

export default component.exports